export default "__VITE_PUBLIC_ASSET__c2700f1a__"